"use client";

import { useState } from "react";
import { Dropdown } from "@vetty/ui";

import { SmallChevronDownIcon } from "@/components";
import { COUNTRIES_DETAILS } from "@/constants";

import styles from "./CountriesFlagsDropdown.module.scss";

/**
 * CountriesFlagsDropdown Component
 *
 * Country flag picker that reports the selected country to the parent.
 *
 * @returns Flag dropdown trigger and list
 */
const CountriesFlagsDropdown = ({
  onChange,
}: {
  onChange: (v: string) => void;
}) => {
  // Default to the catalog’s preset country so the prefix starts filled in
  const [selectedCountry, setSelectedCountry] = useState(
    COUNTRIES_DETAILS[173]
  );

  // Remember the row and tell the parent so the phone prefix can update
  const handleClickItem = (item: (typeof COUNTRIES_DETAILS)[number]) => {
    setSelectedCountry(item);
    onChange(item as unknown as string);
  };

  return (
    <>
      {/* Closed-by-default country menu next to the phone field */}
      <Dropdown>
        {/* Current flag plus chevron that opens the list */}
        <Dropdown.Trigger>
          <div className={styles["comp__trigger"]}>
            <img
              src={selectedCountry.image}
              className={styles["comp__trigger__icon"]}
            />

            <div className={styles["comp__trigger__arrow"]}>
              {/* Shows the menu can expand */}
              <SmallChevronDownIcon />
            </div>
          </div>
        </Dropdown.Trigger>

        {/* Flag + name rows for every country */}
        <Dropdown.Content
          sideOffset={16}
          className={styles["comp__content"]}
          width={"trigger"}
          align={"start"}
        >
          {/* One selectable country row */}
          {COUNTRIES_DETAILS.map((item: any) => (
            <Dropdown.Item key={item.name}>
              <div
                onClick={() => handleClickItem(item)}
                className={styles["comp__item"]}
              >
                <img src={item.image} className={styles["comp__item__icon"]} />
                <div className={styles["comp__item__label"]}>
                  {item.name} ({item.phone})
                </div>
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Content>
      </Dropdown>
    </>
  );
};

export { CountriesFlagsDropdown };
